import { forwardRef, ReactNode } from 'react';

import { Overlay } from '@/components/ui/Overlay/Overlay';
import { ModalPosition } from '@/constants/common';

import * as S from './Modal.styles';

interface ModalProps {
  children: ReactNode;
  dataCy?: string;
  onClose: () => void;
  position?: ModalPosition;
  isOpen?: boolean;
  className?: string;
  transition?: string;
  bottomSheet?: boolean;
}

export const Modal = forwardRef<HTMLDivElement, ModalProps>(
  (
    {
      children,
      dataCy,
      onClose,
      position = 'center',
      isOpen = true,
      className,
      transition,
      bottomSheet
    },
    ref
  ) => {
    return (
      <>
        {isOpen && <Overlay zIndex={50} onClick={onClose} />}
        <S.ModalWrapper
          data-testid="modal"
          data-cy={dataCy}
          $transition={transition}
          $position={position}
          $isOpen={isOpen}
          $bottomSheet={bottomSheet}
          ref={ref}
          className={className}
        >
          {children}
        </S.ModalWrapper>
      </>
    );
  }
);

Modal.displayName = 'Modal';
